<template>
  <el-container class="manamement">
    <!-- 头部区域 -->
    <el-header>
      <div>
        <img src="../../assets/images/logo.png" alt="">
        <!-- <span>智会云官网管理系统</span> -->
      </div>
      <div class="header-btn">
        <!-- 切换语言 -->
        <div class="lang-switch mr-lg-3 mb-2 mb-lg-0">
          <b-dropdown
            :text="currentLocaleText"
            size="sm"
            class="lang-dropdown"
            @click="$event.stopPropagation()"
          >
            <b-dropdown-item
              active-class="active"
              :active="currentLocale === 'zh-CN'"
              @click="switchLanguage('zh-CN')"
            >
              中文
            </b-dropdown-item>
            <b-dropdown-item
              active-class="active"
              :active="currentLocale === 'en-US'"
              @click="switchLanguage('en-US')"
            >
              English
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <el-button type="info" @click="logout">退出</el-button>
      </div>
    </el-header>
    <!-- 页面主体区域 -->
    <el-container>
      <!-- 侧边栏 -->
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <div class="toggle-button" @click="toggleCollapse"><span :class="isCollapse ? 'collapseAfter' : 'collapseBefore'">|||</span></div>
        <!-- 侧边栏菜单区域 -->
        <el-menu background-color="#333744" text-color="#fff" active-text-color="#409EFF" :collapse="isCollapse" :collapse-transition="false" router>
          <!-- 一级菜单 -->
          <el-menu-item index="/management/home">
            <i class="iconfont icon-beijingtupian fonts-icon"></i>
            <span>网站首页</span>
          </el-menu-item>

          <el-menu-item index="/management/editSystemSettings">
            <i class="el-icon-setting fonts-icon"></i>
            <span>系统设置</span>
          </el-menu-item>

          <el-menu-item index="/management/editAboutWe">
            <i class="iconfont icon-guanyuwomen fonts-icon"></i>
            <span>关于我们</span>
          </el-menu-item>

          <el-menu-item index="/management/editNewsList">
            <i class="iconfont icon-xinwen fonts-icon"></i>
            <span>新闻资讯</span>
          </el-menu-item>

          <el-menu-item index="/management/editProductList">
            <i class="iconfont icon-chanpin1 fonts-icon"></i>
            <span>产品展示</span>
          </el-menu-item>

          <el-menu-item index="/management/editCustomerCase">
            <i class="iconfont icon-wodekehu fonts-icon"></i>
            <span>客户案例</span>
          </el-menu-item>

          <el-menu-item index="/management/editTechnical">
            <i class="el-icon-document" style="width: 20px;"></i>
            <span>技术文档</span>
          </el-menu-item>

          <el-menu-item index="/management/editContactUs">
            <el-badge :value="unreadCount" :hidden="unreadCount==0" :max="99">
              <i class="iconfont icon-guanyuwomen fonts-icon"></i>
              <span>联系我们</span>
            </el-badge>
          </el-menu-item>

        </el-menu>
      </el-aside>
      <!-- 右侧内容主体 -->
      <el-main>
        <!-- 路由占位符 -->
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { getUnreadCount } from '@/api/editContactUs'
import { loadMediaCompressionSettings as fetchMediaCompressionSettings } from '@/api/adminV1'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      isCollapse: false, // 是否折叠
      unreadCount: 0, // 未读消息数量
      socket: null // websocket对象
    }
  },
  computed: {
    currentLocale () {
      return localStorage.getItem('dataLocale') || 'zh-CN'
    },
    currentLocaleText () {
      return this.currentLocale === 'zh-CN' ? '中文' : 'English'
    }
  },
  created () {
    this.loadMediaCompressionSettings()
    this.updateUnreadCount()
    this.initSocket()
    // 监听更新
    this.$bus.$on('updateUnreadCount', this.updateUnreadCount)
  },
  beforeDestroy () {
    // 关闭WebSocket连接
    if (this.socket) {
      this.socket.close()
    }
    // 组件销毁前移除监听
    this.$bus.$off('updateUnreadCount', this.updateUnreadCount)
  },
  methods: {
    loadMediaCompressionSettings () {
      fetchMediaCompressionSettings().catch(() => {})
    },
    initSocket () {
      if (typeof (WebSocket) === 'undefined') {
        this.$message.error('Your browser does not support sockets')
      } else {
        // 实例化socket
        this.socket = new WebSocket('wss://gzzhyun.com/socketHandler?id=1')
        // 监听socket连接
        this.socket.onopen = this.open
        // 监听socket错误信息
        this.socket.onerror = this.error
        // 监听socket消息
        this.socket.onmessage = this.getMessage
      }
    },
    open: function () {
      console.log('连接成功')
    },
    error: function () {
      console.log('连接错误')
    },
    getMessage: function (msg) {
      var mesgData = JSON.parse(msg.data)
      // 收到留言信息
      if (mesgData.instruct == 1) {
        this.updateUnreadCount()
        // 触发更新留言列表的事件
        this.$bus.$emit('updateGetMessage')
      }
    },
    // 退出管理平台
    logout () {
      Cookies.remove('TokenKey')
      const path = this.currentLocale === 'en-US' ? '/en/' : '/zh-cn/'
      this.$router.push({ path })
    },
    // 点击按钮,切换菜单的折叠与展开
    toggleCollapse () {
      this.isCollapse = !this.isCollapse
    },
    updateUnreadCount () {
      getUnreadCount().then(res => {
        if (res.code == 0) {
          this.unreadCount = res.data.unreadCount
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 切换语言获取不同数据
    switchLanguage (locale) {
      if (localStorage.getItem('dataLocale') === locale) return
      localStorage.setItem('dataLocale', locale)
      const route = this.$route || {}
      const isNewsContent = (route.path === '/management/editNewsItem' || route.name === '/management/editNewsItem')
      const isProductList = (route.path === '/management/editProductItem' || route.name === '/management/editProductItem')
      const isCaseContent = (route.path === '/management/editCustomerCaseItem' || route.name === '/management/editCustomerCaseItem')
      const isTechnical = (route.path === '/management/editTechnicalItem' || route.name === '/management/editTechnicalItem')
      if (isNewsContent) {
        this.$router.push({ path: '/management/editNewsList' })
      } else if (isProductList) {
        this.$router.push({ path: '/management/editProductList' })
      } else if (isCaseContent) {
        this.$router.push({ path: '/management/editCustomerCase' })
      } else if (isTechnical) {
        this.$router.push({ path: '/management/editTechnical' })
      }
      window.location.reload()
    }
  }
}
</script>

<style lang="less" scoped>
.manamement{
  height: 100%;
}
.el-header{
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  >div{
    height: 80%;
    img{
      height: 100%;
    }
  }
}
.el-aside{
  background-color: #333744;
  .toggle-button{
    background-color: #4a5064;
    font-size: 10px;
    line-height: 30px;
    color: #fff;
    text-align: center;
    letter-spacing: 0.2em;
    cursor: pointer;
  }
  .el-menu{
    border-right: none;
  }
}
.el-main{
  background-color: #eaedf1;
}
.fonts-icon{
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}
.collapseAfter{
  width: 64px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 10px;
  display: block;
  animation: collapseAfter 0.6s;
}
.collapseBefore{
  width: 200px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 10px;
  display: block;
  animation: collapseBefore 0.6s;
}
@keyframes collapseAfter
{
  from {
    transform: rotate(180deg);
    opacity: 0.5;
  }
  to {
    transform: rotate(0deg);
    opacity: 1;
  }
}
@keyframes collapseBefore
{
  from {
    transform: rotate(0deg);
    opacity: 0.5;
  }
  to {
    transform: rotate(180deg);
    opacity: 1;
  }
}

.header-btn{
  display: flex;
  align-items: center;
}
.lang-switch {
  margin-right: 20px;
  display: flex;
  align-items: center;

  .lang-dropdown {
    min-width: 100px;
  }

  :deep(.dropdown-toggle) {
    padding: 0.25rem 0.75rem;
    font-size: 0.875rem;
    white-space: nowrap;
  }

  :deep(.dropdown-menu) {
    min-width: 100px;
  }

  :deep(.dropdown-item) {
    font-size: 0.875rem;
    padding: 0.5rem 1rem;

    &.active {
      background-color: #007bff;
      color: #fff;
    }

    &:hover {
      background-color: #f8f9fa;
    }

    &.active:hover {
      background-color: #0056b3;
    }
  }
}
</style>
